import styled from '../../utils/styled'

type EmployeeAvatarProps = {
  avatarSize?: number
}

export const EmployeeAvatar = styled.img<EmployeeAvatarProps>`
  width: ${({ avatarSize }) => (avatarSize ? `${avatarSize}px` : '50px')};
  height: ${({ avatarSize }) => (avatarSize ? `${avatarSize}px` : '50px')};
  border-radius: 50%;
  margin-right: 10px;
  background-color: black;
  object-fit: contain;
`
